/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReproductiveHealthDayDto } from './ReproductiveHealthDayDto';
import {
    ReproductiveHealthDayDtoFromJSON,
    ReproductiveHealthDayDtoFromJSONTyped,
    ReproductiveHealthDayDtoToJSON,
    ReproductiveHealthDayDtoToJSONTyped,
} from './ReproductiveHealthDayDto';

/**
 * 
 * @export
 * @interface ReproductiveHealthMonthResponseDto
 */
export interface ReproductiveHealthMonthResponseDto {
    /**
     * Rendered month in YYYY-MM format.
     * @type {string}
     * @memberof ReproductiveHealthMonthResponseDto
     */
    month: string;
    /**
     * Selected calendar date in YYYY-MM-DD format.
     * @type {string}
     * @memberof ReproductiveHealthMonthResponseDto
     */
    selectedDate: string;
    /**
     * Timezone offset used for date calculations.
     * @type {string}
     * @memberof ReproductiveHealthMonthResponseDto
     */
    timezoneOffset: string;
    /**
     * Selected day details.
     * @type {ReproductiveHealthDayDto}
     * @memberof ReproductiveHealthMonthResponseDto
     */
    selectedDay?: ReproductiveHealthDayDto;
    /**
     * All days in the rendered month.
     * @type {Array<ReproductiveHealthDayDto>}
     * @memberof ReproductiveHealthMonthResponseDto
     */
    days: Array<ReproductiveHealthDayDto>;
}

/**
 * Check if a given object implements the ReproductiveHealthMonthResponseDto interface.
 */
export function instanceOfReproductiveHealthMonthResponseDto(value: object): value is ReproductiveHealthMonthResponseDto {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('selectedDate' in value) || value['selectedDate'] === undefined) return false;
    if (!('timezoneOffset' in value) || value['timezoneOffset'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    return true;
}

export function ReproductiveHealthMonthResponseDtoFromJSON(json: any): ReproductiveHealthMonthResponseDto {
    return ReproductiveHealthMonthResponseDtoFromJSONTyped(json, false);
}

export function ReproductiveHealthMonthResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReproductiveHealthMonthResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'],
        'selectedDate': json['selectedDate'],
        'timezoneOffset': json['timezoneOffset'],
        'selectedDay': json['selectedDay'] == null ? undefined : ReproductiveHealthDayDtoFromJSON(json['selectedDay']),
        'days': ((json['days'] as Array<any>).map(ReproductiveHealthDayDtoFromJSON)),
    };
}

export function ReproductiveHealthMonthResponseDtoToJSON(json: any): ReproductiveHealthMonthResponseDto {
    return ReproductiveHealthMonthResponseDtoToJSONTyped(json, false);
}

export function ReproductiveHealthMonthResponseDtoToJSONTyped(value?: ReproductiveHealthMonthResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'selectedDate': value['selectedDate'],
        'timezoneOffset': value['timezoneOffset'],
        'selectedDay': ReproductiveHealthDayDtoToJSON(value['selectedDay']),
        'days': ((value['days'] as Array<any>).map(ReproductiveHealthDayDtoToJSON)),
    };
}

